export const zIndex = {
  modal: 1000,
  toast: 1050,
  tooltip: 1100,
}
